<div>
  @if (errorMessage()) {
    <div class="errorMessage">
      {{ errorMessage() }}
    </div>
  }
  @if (isBusy()) {
    <div class="busyIndicator">
      <mat-progress-spinner diameter="24" mode="indeterminate" strokeWidth="1"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  }
  @if (contacts()) {
    <div class="results">
      <table class="resultsTable">
        <thead>
          <tr>
            <td class="tableCell centeredCell headerCell">Contact Type</td>
            <td class="tableCell centeredCell headerCell">Name</td>
            <td class="tableCell centeredCell headerCell">Phone Number</td>
            <td class="tableCell centeredCell headerCell">Email Address</td>
          </tr>
        </thead>
        @for (contact of contacts(); track contact) {
          <tr>
            <td class="tableCell">{{ contact.contactType }}</td>
            <td class="tableCell">{{ contact.contact }}</td>
            <td class="tableCell">{{ contact.phoneNumber }}</td>
            <td class="tableCell">{{ contact.emailAddress }}</td>
          </tr>
        }
      </table>
    </div>
  }
</div>
